export enum NewSchemaFormFieldNames {
	UiSchemaName = "uiSchemaName",
	UiSchemaValue = "uiSchemaValue",
}

export enum ApiResponseMessages {
	Success = "Success",
}
